import React from 'react';

interface ImportFormFieldsProps {
  title: string;
  description: string;
  onTitleChange: (title: string) => void;
  onDescriptionChange: (description: string) => void;
}

const ImportFormFields: React.FC<ImportFormFieldsProps> = ({
  title,
  description,
  onTitleChange,
  onDescriptionChange,
}) => {
  return (
    <>
      {/* Title Input */}
      <div>
        <label
          htmlFor='import-title'
          className='block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2'
        >
          Title <span className='text-red-500'>*</span>
        </label>
        <input
          id='import-title'
          type='text'
          required
          value={title}
          onChange={e => onTitleChange(e.target.value)}
          placeholder='e.g., March 2024 Office Expenses'
          className='w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100 placeholder-gray-400 dark:placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent'
        />
      </div>

      {/* Description Textarea */}
      <div>
        <label
          htmlFor='import-description'
          className='block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2'
        >
          Description (optional)
        </label>
        <textarea
          id='import-description'
          value={description}
          onChange={e => onDescriptionChange(e.target.value)}
          placeholder='Add a description for this bulk upload...'
          rows={3}
          className='w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100 placeholder-gray-400 dark:placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent resize-none'
        />
      </div>
    </>
  );
};

export default ImportFormFields;
